export const FIELD_MAPPINGS = {
  email: 'email',
  firstname: 'firstName',
  lastname: 'lastName',
  sso: 'sso',
  client: 'clientName',
  activestatus: 'activeFlag',
  userrole: 'roleName',
  expirationdate: 'expirationDate',
  privilege: 'privileges',
  assignmenttype: 'assignmentType',
  assignment: 'assignments',
};

export const MIN_COLUMNS_NUMBER = 11;
export const MAX_COLUMNS_NUMBER = 11;
